import React from 'react';
import Typography from 'Components/DesignSystem/Typography/Typography';
import InfoTooltip from 'Components/DesignSystem/Tooltip/InfoTooltip';

interface ConfigFieldRowProps {
  testId: string;
  label: string;
  description?: string;
  /** Draws the required marker after the label; the rule itself is `validateValue`'s. */
  required?: boolean;
  hideLabel?: boolean;
  children: React.ReactNode;
}

/** One row: control on the left, label + tooltip column on the right. Purely
 * presentational — every prop is passed explicitly by the field that uses it. */
const ConfigFieldRow: React.FC<ConfigFieldRowProps> = ({
  testId, label, description, required = false, hideLabel = false, children,
}) => (
  <div
    className="tw-flex tw-flex-wrap tw-gap-4 tw-py-2.5 tw-border-b tw-border-edge last:tw-border-b-0"
    data-testid={testId}
  >
    <div className="tw-flex-1 tw-min-w-[220px] tw-order-2 tw-flex tw-flex-col tw-gap-1.5">{children}</div>
    {!hideLabel && (
      <div className="tw-min-w-[150px] tw-order-1">
        <div className="tw-flex tw-items-center tw-gap-1.5">
          <Typography
            variant="title-header"
            className="tw-text-ink tw-whitespace-nowrap"
            data-testid={`${testId}-label`}
          >
            {label}
          </Typography>
          {/* Same type token as the label, `aria-hidden`: the `FieldTitle` pattern. */}
          {required && (
            <Typography
              variant="title-header"
              as="span"
              className="tw-text-tone-danger-ink"
              aria-hidden="true"
              data-testid={`${testId}-required`}
            >
              *
            </Typography>
          )}
          {description && <InfoTooltip message={description} />}
        </div>
      </div>
    )}
  </div>
);

export default ConfigFieldRow;
